export default "__VITE_ASSET__d98d2a0f__"